<template>
  <div :class="`center_item ${item.style}`" @click="handleClick">
    <div class="system_name">
      <div class="sytem_name_inline">
        <i :class="`iconfont system_icon ${item.icon}`"></i>
        <span class="system_title">{{ item.name }}</span>
      </div>
      <i class="iconfont icontiaozhuan system_go"></i>
    </div>
    <div v-if="item.description" class="system_description">
      <span class="description_text"> {{ item.description }}</span>
    </div>
    <div v-else class="system_description">
      <div class="menu_group" v-for="i in item.span" :key="i">
        <span
          class="menu_item"
          v-for="(menu, j) in item.menus.slice(
            (i - 1) * num,
            (i - 1) * num + num
          )"
          :key="j"
        >
          {{ menu.name }}
        </span>
        <!-- {{ item.menus.length / item.span }} -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemItem",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    num() {
      return Math.ceil(this.item.menus.length / this.item.span);
    }
  },
  methods: {
    handleClick() {
      console.log("go:", this.item.url);
      if (this.item.blank) {
        window.open(this.item.url, "_blank");
      } else {
        this.$router.push(this.item.url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.center_item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 16px;
  margin-bottom: 24px;
  padding: 48px 56px;
  &:hover {
    .system_name {
      .system_icon {
        transition: all 0.8s;
        width: 0px;
        font-size: 1px;
        opacity: 0;
        margin-right: 0px;
      }
      .system_go {
        transition: all 0.5s;
        font-size: 64px;
      }
    }
  }
  cursor: pointer;
  .system_name {
    height: 69px;
    color: #fff;
    font-size: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .system_icon {
      font-size: 64px;
      margin-right: 16px;
    }
    .system_go {
      font-size: 0px;
      margin-left: 16px;
    }
  }
  .system_description {
    display: flex;
    flex-wrap: wrap;
    font-size: 18px;
    margin-top: 16px;
    opacity: 0.7;
    color: #fff;
    .description_text {
      line-height: 30px;
    }
    .menu_group {
      display: flex;
      flex-direction: column;
      .menu_item {
        margin-bottom: 10px;
      }
    }
    .menu_group + .menu_group {
      margin-left: 40px;
    }
  }
}
.sytem_name_inline {
  display: flex;
  height: 69px;
  align-items: center;
}
.center_system1 {
  width: 576px;
  height: 248px;
  // flex-shrink: 0;
}
.center_system2 {
  width: 576px;
  height: 520px;
  // flex-shrink: 0;
}
// .center_system3 {
//   width: 1174px;
//   height: 248px;
//   // flex-shrink: 0;
// }
.system_lightblue {
  background-color: #3aadff;
  box-shadow: 0px 4px 16px 0px rgba(58, 173, 255, 0.6);
  &:hover {
    box-shadow: 0px 10px 16px 0px rgba(58, 173, 255, 0.8);
  }
}
.system_lightgreen {
  background: #5cc7cf;
  box-shadow: 0px 4px 16px 0px rgba(92, 199, 207, 0.6);
  &:hover {
    box-shadow: 0px 10px 16px 0px rgba(92, 199, 207, 0.8);
  }
}
.system_blue {
  background-color: #4971f1;
  box-shadow: 0px 4px 16px 0px rgba(73, 113, 241, 0.6);
  &:hover {
    box-shadow: 0px 10px 16px 0px rgba(73, 113, 241, 0.8);
  }
}
.system_darkblue {
  background-color: #4550ee;
  box-shadow: 0px 4px 16px 0px rgba(69, 80, 238, 0.6);
  &:hover {
    box-shadow: 0px 10px 16px 0px rgba(69, 80, 238, 0.8);
  }
}
.system_orange {
  background-color: #f2af50;
  box-shadow: 0px 4px 16px 0px rgba(242, 175, 80, 0.6);
  &:hover {
    box-shadow: 0px 10px 16px 0px rgba(242, 175, 80, 0.8);
  }
}
.system_innovation {
  background-image: url(~assets/img/home/bg_menu_innovation.png);
}
.system_operation {
  background-image: url(~assets/img/home/bg_menu_operation.png);
}
.system_course {
  background-image: url(~assets/img/home/bg_menu_course.png);
}
</style>
